/**
 * Label Component
 */

import { getBackgroundColorClassName, getTextColorClassName } from '../../../styles/colors';
import './styles.scss';

import { extend } from 'lodash';
import * as React from 'react';
import * as BEM from 'react-bem-helper';

import LinkButton from '../../buttons/LinkButton';
import EllipsisLabel from '../EllipsisLabel';

interface IOwnProps extends IHyperlinkProps, ITextColorProps, IBackgroundColorProps, ILabelWithEllipsis {
  children?: string | React.ReactNode;
  className?: string;
  htmlFor?: string;
  maxTextLength?: number;
  style?: React.CSSProperties;
  size?: LabelSize;
  text?: string;
  variant?: LabelVariant;
  WrappedComponent?: string;
}
export type LabelProps = IOwnProps;

export function Paragraph(props: IOwnProps) {
  const {
    WrappedComponent,
    ...labelProps
  } = props;

  return (
    <Label {...labelProps} WrappedComponent="p" />
  );
}

export function Span(props: IOwnProps & { block?: boolean; }) {
  const {
    block,
    style,
    WrappedComponent,
    ...labelProps
  } = props;

  let spanStyle: React.CSSProperties | undefined = style;

  if (block) {
    const display: React.CSSProperties = {
      display: 'block',
    };

    spanStyle = style ?
      extend(style, display)
      : display;
  }

  return (
    <Label {...labelProps} style={spanStyle} WrappedComponent="span" />
  );
}

export default class Label extends React.Component<IOwnProps> {
  public static defaultProps: IOwnProps = {
    variant: 'label',
    WrappedComponent: 'label',
  };

  private bem;

  constructor(props) {
    super(props);

    this.bem = new BEM(this.props.variant!);
  }

  componentWillReceiveProps(nextProps: IOwnProps) {
    if (nextProps.variant !== this.props.variant) {
      this.bem = new BEM(nextProps.variant!);
    }
  }

  render() {
    const {
      backgroundColor,
      children,
      className,
      htmlFor,
      hyperLinkProps,
      maxTextLength,
      style,
      size,
      text,
      textColor,
    } = this.props;

    // Props with default values
    const variant = this.props.variant!;
    let WrappedComponent = this.props.WrappedComponent!;

    // If variant is a not 'label', make sure the WrappedComponent is not <label>
    if (variant !== 'label' && WrappedComponent === 'label') {
      WrappedComponent = 'span';
    }

    // Implement text/background color classes
    const extraClasses = [
      getTextColorClassName(textColor),
      getBackgroundColorClassName(backgroundColor),
      className,
    ];

    // Group props for render
    const props: any = {
      ...this.bem('', size, extraClasses),
    };

    // If prop htmlFor is set, push it to the component
    if (htmlFor && WrappedComponent === 'label') {
      props.htmlFor = htmlFor;
    }

    const label: React.ReactNode = !!text ?
      <EllipsisLabel text={text} length={maxTextLength || -1} tail="&hellip;" />
      : children;

    return (
      <WrappedComponent {...props} style={style}>
        {hyperLinkProps ? (
          <LinkButton to={hyperLinkProps.href} external={hyperLinkProps.external} variant="text">
            {label}
          </LinkButton>
        ) : label}
      </WrappedComponent>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/text/Label/index.tsx